export { default } from './WelcomeSpeech';
